import { isNumber, isString } from "lodash";

export interface Value {
  name: string;
  label: string;
}

abstract class Type<T extends Value> {
  /**
   * Get a copy of the values.
   * Name is the lowercase unique key.
   * Label is the pretty formatted unique key.
   *
   * @returns values
   */
  abstract values: () => Array<T>;

  /**
   * Parse the supplied value and return the located type or undefined if not located.
   *
   * @param {Number|String} value
   * @returns type or undefined
   */
  parse(value: number | string | T | undefined): T | undefined {
    if (isNumber(value)) {
      return this.values()[value];
    } else if (isString(value)) {
      return this.values().find((v: Value) => [v.name, v.label].includes(value));
    } else if (value?.name) {
      return this.parse(value.name);
    }
  }
}

export default Type;
